export default __webpack_public_path__ + "static/media/18.e40441e5.svg";